import styled, { css } from "styled-components";
export const StyledTrialBannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  transition: all ease-in-out 0.3s;
  z-index: 999;

  .trial-banner {
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    color: var(--white);
    background: linear-gradient(90deg, #317bff 0%, #874bff 65%, #fdb409 100%);
    max-height: 80px;
    opacity: 1;
    overflow: hidden;
    transition: all 0.350s ease-in-out;

    &.closing {
      max-height: 0;
      opacity: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin: 0;
    }

    .content-holder {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 50px;
    }
  }

  .trial-banner-text {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;

    .trial-banner-upgrade-text {
      font-weight: 300;
    }
  }

  .trial-banner-actions {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .upgrade-btn {
    font-size: 12px;
    line-height: 16px;
    padding: 8px 14px;
  }

  .trial-banner-close-btn {
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

/* Chrome offsets, driven by the fixed TopBar (and the contextual Header where it
   renders). Kept as custom properties so the padding and every min-height /
   height calc below stay in sync from one place. */
export const StyledLayout = styled.div`
  max-width: 100%;
  /* clip, not hidden: hidden makes the layout a scroll box of its own, and
     every sticky element on every page (the contacts filters, table headers)
     then sticks to it instead of to the window, which means never. */
  overflow-x: clip;
  --topbar-height: 64px;
  --banner-offset: 0px;
  --header-height: ${({ $hasHeader }) => ($hasHeader ? '50px' : '0px')};
  --chrome-offset: calc(var(--banner-offset) + var(--topbar-height) + var(--header-height));

  @media (min-width: 1450px) {
    --header-height: ${({ $hasHeader }) => ($hasHeader ? '60px' : '0px')};
  }

  .trial-banner-visible & {
    --banner-offset: 42px;
  }

  /* Padding is the only thing that animates here — it reflows when the trial
     banner opens or closes. */
  transition: padding 0.35s ease-in-out;

  ${({ $showlayout }) =>
    $showlayout
      ? css`
          padding: var(--chrome-offset) 15px 0;

          @media (min-width: 992px) {
            padding: var(--chrome-offset) 0 0;
          }
        `
      : css`
          padding: 0px;
        `}

  /* Demo data is view-only (see Layout): nothing in the page looks clickable,
     and the hover-only "Coming soon" labels stay hidden. */
  .children.demo-readonly,
  .children.demo-readonly * {
    cursor: default !important;
  }

  .children.demo-readonly [data-coming-soon]::after {
    display: none;
  }

  /* Controls stop reacting to the pointer at all, so no hover or pressed
     state suggests they can be used. Scroll areas are plain containers, so
     the page and its panes still scroll. */
  .children.demo-readonly :is(
      button,
      a,
      input,
      select,
      textarea,
      label,
      summary,
      tr,
      [role='button'],
      [role='tab'],
      [role='option'],
      [role='checkbox'],
      [role='switch'],
      [tabindex]:not([tabindex='-1'])
    ) {
    pointer-events: none;
  }

  .children {
    width: 100%;
    transition: padding 0.35s ease-in-out, min-height 0.35s ease-in-out;

    &.unibox-layout {
      display: flex;
      flex-direction: column;
      height: calc(100dvh - var(--chrome-offset));
      max-height: calc(100dvh - var(--chrome-offset));
      min-height: 0 !important;
      overflow: hidden;
    }

    ${({ $showlayout }) =>
    $showlayout
      ? css`
            min-height: calc(100dvh - var(--chrome-offset));

            .automation-builder-page & {
              min-height: 100dvh;
            }
          `
      : css`
            /* background: #fafcff; */
          `}
  }
`;
